<template>
    <div id="materCode">
        <el-col style="width:100%">
            <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" :label-position="labelPosition">
                <el-form-item style="margin-bottom: 15px;width:150px">
                    <el-select clearable filterable v-model="defaultBrandId" placeholder="请选择品牌"  @change="showBrand">
                        <el-option 
                            :label="item.brandName" 
                            :value="item.brandId" 
                            v-for="(item,index) in brandLists" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;width:150px">
                    <el-select clearable filterable v-model="defaultCategoryId" placeholder="请选择品类"  @change="showCategory">
                        <el-option 
                            :label="item.categoryName" 
                            :value="item.categoryId" 
                            v-for="(item,index) in categoryLists" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;width:150px">
                    <el-select clearable filterable v-model="defaultModelId" placeholder="请选择型号"  @change="showModel">
                        <el-option 
                            :label="item.modelName" 
                            :value="item.modelId" 
                            v-for="(item,index) in modelLists" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;width:150px">
                    <el-select clearable filterable v-model="defaultClassificationId" placeholder="请选择物料分类"  @change="showClass">
                        <el-option 
                            :label="item.classificationName" 
                            :value="item.classificationId" 
                            v-for="(item,index) in classDialogList" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;width:150px">
                    <el-input clearable maxlength="50" v-model.trim="searchForm.materialName" placeholder="请输入物料名称"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;width:150px">
                    <el-input clearable v-model.trim="searchForm.materialCode" placeholder="请输入物料编号"></el-input>
                </el-form-item>
                <el-form-item label="启用状态：">
                    <el-switch v-model.trim="defaultInitiateMode" :active-value="1" :inactive-value="-1" ></el-switch>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;">
                    <el-button type="primary" size="small" @click="onSubmit()">查询</el-button>
                    <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                </el-form-item>
                <el-form-item class="fr">
                    <el-col style="text-align:right">
                        <el-button size="medium" type="success" v-if="basicsAuth.insertMaterialManagement" @click="createMater">新建物料</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-col>
        <el-card class="box-card">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号"
                    width="120">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="brandName"
                    label="品牌">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="categoryName"
                    label="品类">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="classificationName"
                    label="物料类型">
                </el-table-column>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="initiateMode"
                    label="状态">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.initiateMode == '1'">启用</span>
                        <span v-if="scope.row.initiateMode == '-1'">停用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作" v-if="basicsAuth.updateMaterialManagement">
                    <template slot-scope="scope">
                        <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>
        <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="600px" @close="emptyDialog('materForm')">
            <el-form ref="materForm" :model="materForm" :rules="materFormRules" label-width="100px" :label-position="labelPosition">
                <el-form-item label="物料编号：" prop="materialCode">
                    <el-input clearable :disabled="canSet" placeholder="请输入物料编号(不超过15位数)" v-model.trim="materForm.materialCode" maxlength="15"></el-input>
                </el-form-item>
                <el-form-item label="物料名称："  prop="materialName">
                    <el-input clearable placeholder="请输入物料名称(不超过50个字)" v-model.trim="materForm.materialName" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="选择品牌：" prop="brandId" v-if="createStutas">
                    <el-select clearable filterable v-model.trim="materForm.brandId" placeholder="请选择品牌" style="width: 100%;"
                    @change="getBrand">
                        <el-option :label="item.brandName" :value="item.brandId" v-for="(item,index) in brandLists" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择品类：" prop="categoryId" v-if="createStutas">
                    <el-select clearable filterable v-model.trim="materForm.categoryId" placeholder="请选择品类" style="width: 100%;"
                    @change="getCategory">
                        <el-option :label="item.categoryName" :value="item.categoryId" v-for="(item,index) in categoryLists":key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择型号：" prop="modelId" v-if="createStutas">
                    <el-select clearable filterable v-model="materForm.modelId" placeholder="请选择型号" style="width: 100%;" @change="getModel">
                        <el-option :label="item.modelName" :value="item.modelId" v-for="(item,index) in modelLists" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择分类：" prop="classificationId" v-if="createStutas">
                    <el-select clearable filterable v-model="materForm.classificationId" placeholder="请选择分类" style="width: 100%;" 
                    @change="getClassDialogLists">
                        <el-option :label="item.classificationName" :value="item.classificationId" v-for="(item,index) in classDialogList" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="启用状态：">
                    <el-switch v-model="materForm.initiateMode" :active-value="1" :inactive-value="-1" ></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('materForm')">添加</el-button>
                <el-button v-else type="success" @click="saveEventFormSubmitBtn('materForm')">保存</el-button> 
                <el-button @click="emptyDialog('materForm')">取 消</el-button> 
            </span> 
        </el-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        selectMaterialClassifications,selectMaterialManagement,insertMaterialManagement,updateMaterialManagement,selectAllBrand,selectCategory,selectModel
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'

    export default {
        name: 'materCode',
        components: {},
        data () {
            return {
                dataList:[],
                exitStutas:false,
                createStutas:true,
                canSet:false,
                defaultBrandId: '',//默认品牌Id
                defaultCategoryId: '',//默认品类Id
                defaultModelId:'',//默认型号Id
                defaultClassificationId:'',
                defaultInitiateMode: 1,
                brandLists:[],
                categoryLists:[],
                modelLists:[],
                ClassLists:[],
                classDialogList:[],
                UsefulLists: [
                    {
                        initiateMode:1,name:"启用"
                    },
                    {
                        initiateMode:-1,name:"停用"
                    },
                ],
                dislogCreate:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改物料",
                    create: "新增物料"
                },
                labelPosition:'left',
                materForm:{
                    materialName: '',
                    materialCode: '',
                    brandId:'',
                    categoryId: '',
                    modelId: '',
                    classificationId: '',//物料分类ID
                    initiateMode: 1,
                },
                materFormRules:{
                    materialCode: [{ required: true, message: "请输入物料编码", trigger: "blur" }],
                    materialName: [{ required: true, message: "请输入物料名称", trigger: "blur" }],
                    brandId: [{ required: true, message: "请选择品牌", trigger: "blur" }],
                    categoryId: [{ required: true, message: "请选择品类", trigger: "blur" }],
                    modelId: [{ required: true, message: "请选择型号", trigger: "blur" }],
                    classificationId: [{ required: true, message: "请选择物料分类", trigger: "blur" }]
                },
                searchForm:{
                    materialName: '',
                    materialCode: '',
                },
                returnData: [],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                basicsAuth:{
                    insertMaterialManagement:false,
                    updateMaterialManagement:false
                }
            }
        },
        mounted () {
            this.getBrandLists();
            this.getMaterialManagementList();
            this.getMaterialDialogClassList();
            this.basicsAuth.insertMaterialManagement= getPermission('/api/basicSetting/MaterialManagement/insertMaterialManagement');
            this.basicsAuth.updateMaterialManagement= getPermission('/api/basicSetting/MaterialManagement/updateMaterialManagement');
        },
        methods: {
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getMaterialManagementList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getMaterialManagementList()
            },
            //获取物料编码 
            getMaterialManagementList() {
                let para={
                    brandId: this.defaultBrandId,
                    categoryId: this.defaultCategoryId,             //默认品类Id
                    modelId: this.defaultModelId,                   //默认型号Id
                    classificationId: this.defaultClassificationId,
                    initiateMode: this.defaultInitiateMode,
                    materialCode: this.searchForm.materialCode,
                    materialName: this.searchForm.materialName,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                selectMaterialManagement(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnData = res.data.results.list;
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status == '100') {
                        this.brandLists = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getBrand(e){
                this.defaultBrandId = e;
                if (this.defaultBrandId) {
                    this.getCategoryList()
                }
            },
            //获取品类
            getCategoryList(){
                const brandId = this.defaultBrandId;
                const brandData = {brandId:brandId};
                selectCategory(brandData).then((res) => {
                    if (res.data.status == '100') {
                        this.categoryLists = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            getCategory(e){
                this.defaultCategoryId = e;
                if (this.defaultCategoryId) {
                    this.getModelList()
                }
            },
            getModel(e){
                this.defaultModelId = e;
                if (this.defaultModelId) {
                    this.getMaterialClassList()
                }
            },
            //获取型号
            getModelList(){
                let para = {
                    brandId:this.defaultBrandId,
                    categoryId:this.defaultCategoryId
                }
                selectModel(para).then(res => {
                    if (res.data.status == '100') {
                        this.modelLists = res.data.results
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取物料分类
            getMaterialClassList() {
                selectMaterialClassifications().then(res => {
                    if (res.data.status == '100') {
                        this.ClassLists = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取物料分类Dialog
            getMaterialDialogClassList() {
                selectMaterialClassifications({initiateMode:1}).then(res => {
                    if (res.data.status == '100') {
                        this.classDialogList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getClassDialogLists(e){
                for (var i in this.classDialogList) {
                    if (e === this.classDialogList[i].classificationId) {
                        this.materForm.classificationName = this.classDialogList[i].classificationName
                        this.materForm.classificationNumber = this.classDialogList[i].classificationNumber
                    }
                }
            },
            //新建物料
            createMater() {
                this.createStutas = true;
                this.exitStutas = false;
                this.dislogCreate = true;
                this.materForm = {
                    classificationName: '',
                    classificationNumber: '',
                    initiateMode: 1,
                };
                this.dialogMenuStatus = "create";
                this.canSet = false;
            },
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            brandId: this.materForm.brandId,
                            categoryId: this.materForm.categoryId,
                            modelId: this.materForm.modelId,
                            classificationId: this.materForm.classificationId,
                            initiateMode: this.materForm.initiateMode.toString(),
                            classificationNumber: this.materForm.classificationNumber,
                            materialName: this.materForm.materialName,
                            materialCode:this.materForm.materialCode
                        }
                        insertMaterialManagement(para).then(res => {
                            if (res.data.status == '100') {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMaterialManagementList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑
            exitBtn(index,item) {
                this.canSet = true
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.materForm = Object.assign({}, item);
                this.exitStutas = true
                this.createStutas =false
            },
            //确定保存
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                      /*获取当前input上输入的文字*/
                        let para={
                            materialCode: this.materForm.materialCode,
                            materialName: this.materForm.materialName,
                            initiateMode: this.materForm.initiateMode.toString(),
                            materialCoding:this.materForm.materialCoding
                        }
                        updateMaterialManagement(para).then(res => {
                            if (res.data.status == '100') {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMaterialManagementList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            showBrand(){
                this.getCategoryList();
                this.defaultCategoryId = "";
                this.defaultModelId = "";
            },
            showCategory(){
                this.defaultModelId = "";
                this.getModelList();
                this.getMaterialManagementList();
            },
            showModel(){
                this.getMaterialClassList();
                this.getMaterialManagementList();
            },
            showClass(){
                this.getMaterialManagementList();
            },
            showUseful(){
                this.getMaterialManagementList();
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogCreate = false
            },
            refresh() {
                this.getMaterialManagementList();
            },
            onSubmit() {
                this.getMaterialManagementList();
            },
            clearFrom(){
                this.searchForm = {}
                this.materForm.brandId="";
                this.materForm.categoryId="";
                this.materForm.modelId="";
                this.materForm.classificationId="";
                this.defaultBrandId = "";
                this.defaultCategoryId = "";
                this.defaultModelId = "";
                this.classificationId = "";
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style lang="scss" type="text/css" scoped>
    #materCode{
        font-size: 14px;
        .headerT{
            margin:8px 0 15px 0;
            width: 80px;
        }
        a{
            color: #000;
        }
        a.headerA{
            margin-top: 5px;
            display:block;
            margin-bottom:10px
        }
        .listPart{
            border:1px solid #c6c6c6;
            margin:0px 10px 10px 0;
            border-radius: 5px;
            text-align: center;
            position: relative;
            z-index: 0;
            cursor: pointer;
            padding: 3px 8px;
            width:130px
        }
        a.active{
            background-color:#1abc9c;
            color:#fff;
            border-color: #1abc9c;
        }
    }
</style>



// WEBPACK FOOTER //
// materCode.vue?f5394092